import { logout } from "@/hooks/useLogin";
import router from "@/router";
import { useMainStore, useStore } from "@/store";
import { filterEmpty } from "@/utils";
import axios from "axios";
import { showFailToast, showSuccessToast, ToastType } from "vant";
import "vant/es/toast/style";
const env = import.meta.env;

const cwArr = [env.VITE_APP_CW_INFO, env.VITE_APP_CW_FORM, env.VITE_APP_CW_FORM_53112, env.VITE_APP_CW_INVOICE, env.VITE_APP_CW_GZB];
const GSArr = [env.VITE_APP_NETFILE];
const crSArr = [env.VITE_APP_AI_SERVER];
const cJArr = [env.VITE_APP_AI_THIRDPARTYTASK];
const noHint = ["/user/checkwxuser"];
// 创建axios 实例
const instance: any = axios.create({
  timeout: 60000,
  responseType: "json",
});
instance.defaults.headers.post["Content-Type"] = "application/json";

// 发送消息
const sendMessage = (message: string, type: ToastType) => {
  console.log(type);

  if (type == "fail") showFailToast(message);
  else if (type == "success") showSuccessToast(message);
};

const STATUS = {
  TOKEN: () => {
    sendMessage("登录过期，请重新登录", "fail");
    setTimeout(() => {
      useStore().setToken("");
      router.replace({ name: "login" });
    }, 500);
  },
  LOGOUT: () => {
    sendMessage("用户已操作退出，请重新登录", "fail");
    setTimeout(() => {
      logout();
    }, 500);
  },
};

// 错误处理
const errorHandle = (response: any) => {
  const status = response.status;
  const other = response?.data?.message || "网络繁忙, 请稍候再试";

  if (noHint.some((n) => response.config?.url.indexOf(n) != -1)) return;
  switch (status) {
    case 401:
      STATUS.TOKEN();
      break;
    case 402:
      STATUS.LOGOUT();
      break;
    case 403:
      STATUS.TOKEN();
      break;
    case 404:
      sendMessage("请求的资源不存在", "fail");
      break;
    case 405:
      sendMessage("您目前的操作有爬虫的嫌疑，请稍后再试！", "fail");
      break;
    default:
      if (other) sendMessage(other, "fail");
  }
};
// 请求拦截器
instance.interceptors.request.use(
  (config: any) => {
    const { url, notToken, isLatest = false } = config;
    if (!notToken) {
      const isCW = cwArr.some((n) => url.startsWith(n));
      const isGS = GSArr.some((n) => url.startsWith(n));
      const isCrS = crSArr.some((n) => url.startsWith(n));
      const isCj = cJArr.some((n) => url.startsWith(n));
      const token = isCW ? useMainStore().getZtToken(isLatest) : isGS ? useMainStore().getGsToken : isCrS ? useMainStore().getCrs_token : isCj ? useMainStore().getCaiJi_token : useStore().getToken;
      config.headers["Authorization"] = token; // 设置请求头
    }
    config.params = filterEmpty(config.params);
    console.log("config", config);
    return config;
  },

  (error: any) => {
    return Promise.reject(error);
  }
);
// 响应拦截器
instance.interceptors.response.use(
  (res: any) => {
    console.log(res);

    if (res.data?.status && res.data.status != 200) {
      errorHandle(res);
      return Promise.reject(res.data);
    } else {
      return Promise.resolve(res.data);
    }
  },
  (error: { response: any }) => {
    console.log("error", error);
    const { response } = error;
    if (response) {
      errorHandle(response);
      return Promise.reject(response);
    }
    return Promise.reject(error);
  }
);
export default instance;
